<template lang="pug">
  e-input-datetime(
    v-model="dateModel"
    :emit-only-on-select-clicked="true"
    clearable
    custom-format="DD.MM.YYYY"
  )
    template(#activator="{ datetime, listeners }")
      div(class="dynamic-date-input-wrapper")
        input(
          v-if="canEdit"
          v-model="inputValue"
          ref="placeholderInput"
          class="dynamic-date-input"
          :class="datepickerClasses"
          :style="datepickerStyles"
          :draggable="true"
          @focus="onFocus"
          @keydown="onKeyDown"
        )
        input(
          v-else
          :value="value"
          ref="dateInput"
          class="dynamic-date-input"
          :class="datepickerClasses"
          :style="datepickerStyles"
          readonly
          :disabled="disableDatepicker"
          :placeholder="placeholder"
          v-on="listeners"
        )
        v-btn(
          small
          icon
          class="dynamic-date-input__icon"
          @click.stop="handleIconClick"
        )
          e-svg-icon(
            v-if="!xsDevice"
            size="sm"
            :name="dateModel ? 'calendar-2-primary' : 'calendar-2'"
          )
</template>

<script>
import EInputDatetime from '~/components/elements/inputs/e-input-datetime'
import ESvgIcon from '~/components/elements/icons/e-svg-icon'
import responsive from '~/mixins/pages/responsive'

export default {
  name: 'TemplatesDynamicDateInput',
  components: {
    EInputDatetime,
    ESvgIcon
  },
  mixins: [responsive],
  props: {
    field: {
      type: Object,
      required: true
    },
    value: {
      type: String,
      default: null
    },
    canEdit: {
      type: Boolean,
      default: false
    },
    fontSize: {
      type: [String, Number],
      default: null
    },
    isResizing: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    hasError: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      dateModel: null,
      inputValue: null
    }
  },
  computed: {
    disableDatepicker() {
      return (!this.field.documentFieldValue && this.field.documentFieldPreValue) || this.isDisabled
    },
    datepickerStyles() {
      return {
        fontSize: this.xsDevice ? '7px' : this.fontSize + 'px'
      }
    },
    datepickerClasses() {
      return {
        filled: this.dateModel,
        'error-state': this.hasError
      }
    }
  },
  watch: {
    dateModel(val) {
      if (val !== this.value) {
        this.$emit('update:value', val)
      }
    },
    value(val) {
      this.dateModel = val
    }
  },
  mounted() {
    this.setDatepicker()
  },
  methods: {
    onFocus() {
      this.$store.commit('templatefields/SET_ACTIVE_FIELD_ID', this.field.id)
      this.$store.commit('templatefields/SET_TOOLBARS_MAP_FIELD_ID', {
        id: this.field.id,
        value: true
      })
    },
    onKeyDown(e) {
      if (e.ctrlKey && e.key === 'c') {
        this.$emit('copy')
      }
      if (e.ctrlKey && e.key === 'x') {
        this.$emit('cut')
      }
      if (e.key === 'Delete') {
        this.$emit('delete')
      }
    },
    setDatepicker() {
      if (this.canEdit) {
        this.inputValue = this.field.hint
      } else if (this.field.documentFieldPreValue) {
        this.dateModel = this.field.documentFieldPreValue
      } else {
        this.dateModel = this.field.documentFieldValue
      }
    },
    handleIconClick() {
      if (this.canEdit) {
        this.$refs.placeholderInput.focus()
      } else {
        this.$refs.dateInput.click()
      }
    }
  }
}
</script>

<style scoped lang="scss">
.dynamic-date-input-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
}
.dynamic-date-input {
  width: 100%;
  height: 100%;

  border-radius: 8px;
  border: 1px solid $primary;
  background: rgba(255, 255, 255, 0.7);
  padding: 8px 24px 8px 8px;
  user-select: none;
  outline: none;
  font-weight: 300;

  @media (max-width: map-get($breakpoints, 'sm')) {
    padding: 0;
    text-align: center;
    border-radius: 4px;
    position: relative;
    top: -8px;
    outline: none;
  }

  &::placeholder {
    color: $text-dark;
  }

  &.filled {
    background:
      linear-gradient(0deg, rgba(143, 37, 125, 0.12) 0%, rgba(143, 37, 125, 0.12)) 100%,
      rgba(255, 255, 255, 0.4);
    color: $primary;
  }

  &.error-state {
    border: 1px solid $danger;
    background: rgba(255, 23, 68, 0.12);
  }

  &__icon {
    width: 16px;
    height: 16px;

    position: absolute;
    top: 50%;
    right: 8px;
    transform: translateY(-50%);
    z-index: map-get($zIndexes, 'base');

    &::before {
      opacity: 0 !important;
    }
  }
}
</style>
